import * as UserActions from '@services/user/user.actions';
import TranslateNew from '@translate/TranslateNew';
import * as React from 'react';
import {connect} from 'react-redux';
import {WithStyles, withStyles} from '@material-ui/core';
import {SelectLanguageStyle as langStyle} from './SelectLanguage.style';




interface IProps extends WithStyles<typeof langStyle> {
  language:string;
  compact? :boolean;
  isOnline: boolean;
  style?:React.CSSProperties;
  selectLanguage: (language:string) => void; // update frontend
  updateLanguage: (data:{language:string, timeZone:string}) => void; // update backend
}

const tn :TranslateNew = TranslateNew.getInstance();

class SelectLanguage extends React.Component<IProps> {

  constructor(props: IProps) {
    super(props);
  }

  public render() {
    return (
    <select
      style={this.props.style}
      className={this.props.classes.dropdown}
      onChange={this.handleSelectLanguage}
      value={this.props.language?this.props.language:"EN"}
    >
      <option value={"EN"} >{this.props.compact?tn.lang.englishCompact:tn.lang.english}</option>
      <option value={"SE"} >{this.props.compact?tn.lang.swedishCompact:tn.lang.swedish}</option>
    </select>
    );
  }

  private handleSelectLanguage = (event:any) => {
    const lan = event.target.value;
    this.props.selectLanguage(lan);
    if (this.props.isOnline) {
      const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
      this.props.updateLanguage({language:lan, timeZone}); 
    }
  }
}

const mapDispatchToProps = {
  selectLanguage: UserActions.selectLanguage,
  updateLanguage: UserActions.storeLanguage,
};

function mapStateToProps(state: any) {

  const isOnline = state.connection.loadCompleted;
  return {
    language:state.user.language,
    isOnline,
  };
}

export default (connect(mapStateToProps, mapDispatchToProps)(withStyles(langStyle)(SelectLanguage)));



// WEBPACK FOOTER //
// ./src/components/common/language/SelectLanguage.tsx